import { baseUrl } from "./baseUrl";
import { fetchJSON } from "./fetchJSON";

export async function verifyCodeInsee(value: string) {
  const url = new URL("/backend/v1/validate-code-insee", baseUrl);
  url.searchParams.append("codeInsee", value);
  return fetchJSON(url);
}